import React, { useRef, useEffect, useState } from 'react';

import D3Component from './D3Component';
import { useBluredItems } from './use-blured-items';

type Props = {
  erasable?: boolean;
  children: any;
  cleared?: boolean;
  blurAmount?: number;
  circleRadius?: number;
  hint?: string;
  onClear?: Function;
  rerender?: boolean;
};

function D3BluredComponent({
  erasable,
  children,
  cleared,
  blurAmount = 10,
  circleRadius = 30,
  hint,
  onClear,
  rerender,
}: Props) {
  const contentRef = useRef(null);
  const [remountD3, setRemountD3] = useState(false);
  const { attributes, style, erased, setErased, showChildren } = useBluredItems(
    blurAmount,
    rerender,
    cleared,
    contentRef
  );

  useEffect(() => {
    setRemountD3(true);
    setTimeout(() => setRemountD3(false));
  }, [rerender]);

  return (
    <>
      {attributes && !showChildren && !remountD3 ? (
        <D3Component
          hint={hint}
          erasable={erasable}
          cleared={cleared}
          attributes={attributes}
          circleRadius={circleRadius}
          onClear={onClear}
          erased={erased}
          setErased={setErased}
        />
      ) : null}
      <div ref={contentRef} style={showChildren ? { padding: style.padding } : style}>
        {children}
      </div>
    </>
  );
}

export default D3BluredComponent;
